import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../api/axios";
import api from "../../api/axios";
/* =========================
   AUTH HEADER
========================= */
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

/* =========================
   ADMIN LOGIN API
========================= */
export const loginUser = createAsyncThunk(
  "user/login",
  async (payload, thunkAPI) => {
    try {
      const res = await axios.post(`${API_URL}/login`, payload);

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("userId", res.data.userId);
      localStorage.setItem("role", res.data.role);

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Login failed"
      );
    }
  }
);

/* =========================
   CREATE USER API
========================= */
export const createUser = createAsyncThunk(
  "user/createUser",
  async (payload, thunkAPI) => {
    try {
      const userId = localStorage.getItem("userId");

      const res = await axios.post(
        API_URL,
        { ...payload, createdBy: userId },
        getAuthHeader()
      );

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to create user"
      );
    }
  }
);

/* =========================
   FETCH USERS API
========================= */
export const fetchUsers = createAsyncThunk(
  "user/fetchUsers",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(API_URL, getAuthHeader());
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch users"
      );
    }
  }
);

/* =========================
   UPDATE PROFILE API
========================= */
export const updateProfile = createAsyncThunk(
  "user/updateProfile",
  async (payload, thunkAPI) => {
    try {
      const res = await api.put(
  "/api/auth/profile",   // ✅ FULL PATH
  payload
);
     
      return res.data.user;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to update profile"
      );
    }
  }
);

/* =========================
   SLICE
========================= */
const userSlice = createSlice({
  name: "user",
  initialState: {
    adminuser: [],
    user: null,           // ← stores logged-in user data
    token: localStorage.getItem("token") || null,
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetUserStatus: (state) => {
      state.success = false;
      state.error = null;
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.adminuser = [];
      localStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder
      /* =========================
         LOGIN
      ========================= */
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* =========================
         CREATE USER
      ========================= */
      .addCase(createUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUser.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* =========================
         FETCH USERS
      ========================= */
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.adminuser = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* =========================
         UPDATE PROFILE
      ========================= */
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
  .addCase(updateProfile.fulfilled, (state, action) => {
  state.loading = false;
  state.success = true;
  state.user = action.payload;

  localStorage.setItem("user", JSON.stringify(action.payload));
})
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUserStatus, logout } = userSlice.actions;
export default userSlice.reducer;